import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://otakufy.live";
const DEFAULT_TITLE =
  "Otakufy — Animedoro Study Timer & Focus App for Anime Fans";
const DEFAULT_DESCRIPTION =
  "Otakufy is the free Animedoro timer: study or focus in 40–60 min sprints, then reward yourself with a 20 min anime break. Customizable focus timer, study rooms, LoFi music, stats & streaks.";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

/**
 * Per-route SEO tags. Gives each page a unique <title>, description and
 * canonical URL so search engines index them distinctly instead of treating
 * the whole SPA as one page.
 */
export default function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  noindex = false,
}) {
  const fullTitle = title
    ? `${title} | Otakufy`
    : DEFAULT_TITLE;
  const canonical = `${SITE_URL}${path}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex ? (
        <meta name="robots" content="noindex, follow" />
      ) : (
        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1"
        />
      )}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Otakufy" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
